import { QueryClient } from '@tanstack/react-query';
import { isSessionError } from './client';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      // An expired session sends the user to login; a retry would only fail the same way
      retry: (failureCount, error) => !isSessionError(error) && failureCount < 1,
      staleTime: 5 * 60 * 1000, // 5 minutes
    },
    mutations: {
      retry: 0,
    },
  },
});
